import {
  REAL_ESTATE_CATEGORY_OPTIONS,
  LISTING_TYPE_OPTIONS,
  LISTING_PROCESSING_STATUS_OPTIONS
} from './../constants/realestate.const';
import {
  CONSULTATION_STATUS,
} from './../constants/contract.constant';

export const accountStatus = (item: any) => {
  if (item.deleted_at !== null) {
    return 'Đã khóa'
  } else {
    if (item.activation_status === true) {
      return 'Đang hoạt động'
    } else {
      return 'Tạm ngưng'
    }
  }
}

export const accountType = (type: string) => {
  return type === 'broker' ? 'Môi giới' : 'Tài khoản thường';
}

export const kycStatus = (item: any) => {
  if (item === null) {
    return 'Chưa KYC'
  }
  if (item?.processing_status === 'pending') {
    return 'Đang KYC'
  } else if (item?.processing_status === 'approved') {
    return 'Đã KYC'
  } else if (item?.processing_status === 'rejected') {
    return 'KYC không thành công'
  }
}

export const getRealestateType = (type: string) => {
  return REAL_ESTATE_CATEGORY_OPTIONS.find((option) => option.value === type).label;
}

export const formatTableDataRealestate = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    code: item.id,
    type: [{
      type: 'info',
      label: getRealestateType(item.real_estate_type)
    }],
    region_lv1: item.province?.name,
    region_lv2: item.district?.name,
    area: item.area,
    map_sheet_number: item.map_sheet_number,
    plot_number: item.plot_number,
    address: item.address || '--',
    coords: '[xem]',
    fist_listing_at: item.created_at,
    regdate: item.created_at,
  }));
}

export const formatTableDataListing = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    id: item.id,
    code: item.id,
    action: [
      {type: 'info', label: 'Đăng tin'},
      // {type: 'danger', label: 'Xoá tin'},
      // {type: 'warning', label: 'Chỉnh sửa tin'},
    ],
    type: [
        {
        type: LISTING_TYPE_OPTIONS.find((option) => option.value === item.listing_type)?.color,
        label: LISTING_TYPE_OPTIONS.find((option) => option.value === item.listing_type)?.label
      },
      item.flash_offer_item_ongoing ? {
        type: 'danger',
        label: item.flash_offer_item_ongoing ? 'Flash Offer' : ''
      } : null
    ].filter(Boolean),
    address: {
      region: `${item?.real_estate?.district?.name}, ${item?.real_estate?.province?.name}`,
      address: item.address || item?.real_estate?.address,
    },
    subject: {
      thumb: item.photos?.[0]?.url?.thumbnail,
      title: item.title,
      attrs: [{
          key: 'Diện tích',
          val: item.area
        },
      ],
      map: {
        map_sheet: item.map_sheet_number || item.real_estate?.map_sheet_number,
        plot_num: item.plot_number || item.real_estate?.plot_number,
      }
    },
    author: {
      id: item.poster?.id,
      profile_pic: 'https://images.unsplash.com/photo-1602866813929-6bc4933c7013?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      code: `#${item.poster?.code}`,
      full_name: item.poster?.full_name,
      phone: item.poster?.phone_number,
      email: item.poster?.email,
    },
    statistic: [{
      key: 'Lượt xem',
      val: item.total_view
    }],
    status: [{
      type: LISTING_PROCESSING_STATUS_OPTIONS.find((option) => option.value === item.processing_status)?.color,
      label: LISTING_PROCESSING_STATUS_OPTIONS.find((option) => option.value === item.processing_status)?.label
    }],
    regdate: item.created_at,
  }));
}

export const formatTableDataConsultations = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    id: item.id,
    status: [{
      type: CONSULTATION_STATUS.find((option) => option.id === item.admin_status)?.color,
      label: CONSULTATION_STATUS.find((option) => option.id === item.admin_status)?.label
    }],
    code: `#${item.id}`,
    code_real_estate: item?.real_estate?.id ? `#${item?.real_estate?.id}` : '--',
    code_listing: item?.listing_id ? `#${item.listing_id}` : '--',
    customer: {
      ...item.customer,
      name: item.customer.name || item.customer.full_name,
      phone: item.customer.phone || item.customer.phone_number,
    },
    content: item.content,
    deliveries_count: item.deliveries_count,
    broker: item.current_delivery ? {
      ...item.current_delivery.broker,
      name: item.current_delivery.broker.name || item.current_delivery.broker.full_name,
      phone: item.current_delivery.broker.phone || item.current_delivery.broker.phone_number,
    } : '',
    created_at: item?.created_at || '',
    approved_at: item?.approved_at || '',
  }));
}
